import React, { useContext, useEffect } from "react";
import { connect } from "react-redux";
import { TableContext, PopupContext } from "../../index";
import { Checkbox } from "../../view/Checkbox";
import { deepCopy, formatReportDate } from "../../utils";
// import dots from "../../_resources/img/vdots.png";
import { POPUP_TYPES } from "../../view/popup/PopupContainer";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { MoreVertical, Eye } from 'lucide-react';

const Severity = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
}

function RemediationTableRow({ data, index, userCapability, hiddenHeaders = [] }) {

    const { setPopup } = useContext(PopupContext);
    const { config, setConfig } = useContext(TableContext);

    useEffect(() => {
        if (userCapability) {
            userCapability.find(item =>
                item.component === "manageparameter" && item.type === "page");
        }
    }, [userCapability]);

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    const getCircleType = () => {
        if (!data.severity) {
            return '';
        }
        switch (data.severity.toLowerCase()) {
            case Severity.HIGH:
                return "severity-high";
            case Severity.MEDIUM:
                return "severity-medium";
            case Severity.LOW:
                return "severity-low";
            default:
                return ''; // Add a default case
        }
    }

    const getValidColor = () => {
        switch (data.valid) {
            case 1:
                return "valid-pass";
            case 0:
                return "valid-fail";
            case -1:
                return "valid-unknown";
            default:
                return ''; // Add a default case
        }
    }

    const getPreviousValidColor = () => {
        switch (data.previousValid) {
            case 1:
                return "valid-pass";
            case 0:
                return "valid-fail";
            case -1:
                return "valid-unknown";
            default:
                return ''; // Add a default case
        }
    }

    const getDateTimeFormat = (timestamp) => {
        const numericTimestamp = Number(timestamp);

        if (!Number.isFinite(numericTimestamp) || numericTimestamp <= 0) {
            return "";
        }

        return formatReportDate(numericTimestamp);
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const onViewOutput = () => {
        handleClose();
        setPopup(
            {
                type: POPUP_TYPES.REMEDIATION_OUTPUT,
                previousOutput: data.previousOutput,
                previousStartTime: data.previousStartTime,
                remediateOutput: data.remediateOutput,
                remediateStartTime: data.remediateStartTime,
                output: data.output,
                startTime: data.startTime,
            },
        );
    }

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td>{data.rule}</td>
            <td>{data.device}</td>
            {hiddenHeaders.includes("SECTION") ? null : <td>{data.sectionName || '-'}</td>}
            {hiddenHeaders.includes("SUBSECTION") ? null : <td>{data.subsectionName || '-'}</td>}
            <td>
                <span className={`oct_severity-badge-v2 ${getCircleType()}`}>
                    {data.severity?.toUpperCase()}
                </span>
            </td>
            <td>
                <span className={`oct_valid-badge-v2 ${getPreviousValidColor()}`}>
                    {data.previousValid === 1 ? 'PASS' : data.previousValid === -1 ? 'UNKNOWN' : 'FAIL'}
                </span>
            </td>
            <td>
                <span className={`oct_valid-badge-v2 ${getValidColor()}`}>
                    {data.valid === 1 ? 'PASS' : data.valid === -1 ? 'UNKNOWN' : 'FAIL'}
                </span>
            </td>
            <td>{data.user}</td>
            <td>{getDateTimeFormat(data.remediateStartTime)}</td>
            <td>
                <button className="oct_dropdown-trigger-v2" onClick={handleClick}>
                    <MoreVertical className="oct_icon" />
                </button>

                <Menu
                    className="oct_menu-v2"
                    id="action-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem className="oct_menu-item-v2" onClick={onViewOutput}>
                        <Eye className="oct_icon" /> View Output
                    </MenuItem>

                </Menu>
            </td>
        </tr>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}
export default connect(mapStateToProps)(RemediationTableRow);
